import { RemToPx } from 'smg/util';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

interface swiperOptions {
    slidesPerView?: number | 'auto';
    slidesPerGroup?: number;
    centeredSlides?: boolean;
    spaceBetween?: number;
}

export function SwiperInit(opts?: swiperOptions) {
    document.querySelectorAll<HTMLElement>('.swiper').forEach($swiper => {
        const s = new Swiper($swiper, {
            modules: [Navigation],

            loop: false,

            direction: $swiper.dataset.direction ? 'vertical' : 'horizontal',

            on: {
                slideChange: () => {
                    if (!$swiper.dataset.direction) {
                        return;
                    }
                    const $container = $swiper.closest<HTMLElement>('.swiper-container');
                    if ($container && s.isBeginning) {
                        toggleVerticalClasses($container, 'bottom');
                    } else if ($container && s.isEnd) {
                        toggleVerticalClasses($container, 'top');
                    } else if ($container) {
                        toggleVerticalClasses($container, 'both');
                    }
                },
                reachBeginning: () => {
                    if (!$swiper.dataset.direction) {
                        return;
                    }
                    const $container = $swiper.closest<HTMLElement>('.swiper-container');
                    if ($container) {
                        toggleVerticalClasses($container, 'bottom');
                    }
                },
                reachEnd: () => {
                    if (!$swiper.dataset.direction) {
                        return;
                    }
                    const $container = $swiper.closest<HTMLElement>('.swiper-container');
                    if ($container) {
                        toggleVerticalClasses($container, 'top');
                    }
                },
            },

            centeredSlides: opts?.centeredSlides || false,
            slidesPerView: opts?.slidesPerView || 'auto',
            slidesPerGroup: opts?.slidesPerGroup || 1,
            watchOverflow: true,

            spaceBetween: opts?.spaceBetween ?? RemToPx(1),

            observeParents: true,
            observeSlideChildren: true,
            observer: true,

            navigation: {
                nextEl: $swiper.dataset.direction ? $swiper.parentElement?.parentElement?.querySelector('.swiper-button-next') as HTMLElement : '.swiper-button-next',
                prevEl: $swiper.dataset.direction ? $swiper.parentElement?.parentElement?.querySelector('.swiper-button-prev') as HTMLElement : '.swiper-button-prev',
            },
        });

        if ($swiper.dataset.direction) {
            if (s.allowSlideNext && s.allowSlidePrev) {
                const $container = $swiper.closest<HTMLElement>('.swiper-container');
                if ($container) {
                    toggleVerticalClasses($container, 'bottom');
                }
            } else {
                const $container = $swiper.closest<HTMLElement>('.swiper-container');
                if ($container) {
                    toggleVerticalClasses($container, 'none');
                }
            }
        }
    });
}

function toggleVerticalClasses($container: HTMLElement, side: 'top' | 'bottom' | 'both' | 'none') {
    switch (side) {
    case 'top':
        $container.classList.remove('fading-bottom-vertical');
        $container.classList.remove('fading-sides-vertical');
        $container.classList.add('fading-top-vertical');
        break;
    case 'bottom':
        $container.classList.remove('fading-top-vertical');
        $container.classList.remove('fading-sides-vertical');
        $container.classList.add('fading-bottom-vertical');
        break;
    case 'both':
        $container.classList.remove('fading-top-vertical', 'fading-bottom-vertical');
        $container.classList.add('fading-sides-vertical');
        break;
    case 'none':
        $container.classList.remove('fading-top-vertical', 'fading-bottom-vertical', 'fading-sides-vertical');
        break;
    }
}